module.exports = __webpack_public_path__ + "static/media/blank-background.0808a197.webp";